import posthog from 'posthog-js';

const compactIdentity = (props: Record<string, unknown>) => {
  return Object.entries(props).reduce<Record<string, unknown>>(
    (acc, [key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        acc[key] = value;
      }
      return acc;
    },
    {}
  );
};

export const getPostHogIdentityProperties = () => {
  const getProperty = (key: string) => (posthog as any).get_property(key);

  return compactIdentity({
    user_id: getProperty('user_id') ?? posthog.get_distinct_id(),
    user_display_name: getProperty('user_display_name'),
    user_first_name: getProperty('user_first_name'),
    user_last_name: getProperty('user_last_name'),
    user_email: getProperty('user_email') ?? getProperty('email'),
    tenant_id: getProperty('tenant_id'),
    association_code: getProperty('association_code'),
    role: getProperty('role'),
    analytics_role_type: getProperty('analytics_role_type'),
    user_type: getProperty('user_type'),
    analytics_user_type: getProperty('analytics_user_type'),
    integration_id: getProperty('integration_id'),
    membership_status: getProperty('membership_status'),
    is_member: getProperty('is_member'),
    platform_is_member: getProperty('platform_is_member'),
    integration_is_member: getProperty('integration_is_member'),
    account_status: getProperty('account_status'),
    community_access: getProperty('community_access'),
    has_organization: getProperty('has_organization'),
  });
};
